import 'twin.macro';
import React from 'react';
import { PuzzlePieceIcon } from '@heroicons/react/24/outline';
import { IconProps } from '@teetsh/app/src/components/Icons/icon';
import { tagBackgroundColors, tagTextColor } from 'styles/userConstants';
import { css } from 'twin.macro';

export function CompetenceIcon(props: IconProps) {
  return (
    <PuzzlePieceIcon
      tw="p-1 rounded-lg"
      css={[
        css`
          background-color: ${tagBackgroundColors['lavande-quiet']};
          color: ${tagTextColor.lavande};
        `,
      ]}
      className={props.className}
      {...props}
    />
  );
}
